import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-info-container',
  templateUrl: './info-container.component.html',
  styleUrls: ['./info-container.component.scss']
})
export class InfoContainerComponent {
  @Input() title='';


  ngOnChanges(changes: SimpleChanges){
    if(changes['title']){
        this.title= changes['title'].currentValue;
    }
  }

}
